module.exports = __webpack_public_path__ + "img/6C.e943f6f4.png";